/**
 * MANAGER-ORDERS-141-R2 — Customer bottom navigation (no hamburger duplicate destinations).
 */
import type { StoreV2Lang } from "./store-v2-locale.js";
import { t } from "./store-v2-ui-copy.js";

export type CustomerBottomNavId = "home" | "search" | "cart" | "cabinet";

export function CustomerBottomNav({
  lang,
  active,
  cartCount,
  onNavigate,
}: {
  lang: StoreV2Lang;
  active: CustomerBottomNavId;
  cartCount: number;
  onNavigate: (id: CustomerBottomNavId) => void;
}) {
  const items: Array<{ id: CustomerBottomNavId; label: string; icon: string; testId: string }> = [
    { id: "home", label: t(lang, "home"), icon: "🏠", testId: "sv2-bottom-nav-home" },
    { id: "search", label: t(lang, "search"), icon: "🔍", testId: "sv2-bottom-nav-search" },
    { id: "cart", label: t(lang, "cart"), icon: "🛒", testId: "sv2-bottom-nav-cart" },
    { id: "cabinet", label: t(lang, "my_cabinet"), icon: "👤", testId: "sv2-bottom-nav-cabinet" },
  ];

  return (
    <nav className="sv2-bottom-nav" data-testid="sv2-bottom-nav" aria-label={lang === "en" ? "Main" : "Головне меню"}>
      {items.map((item) => {
        const isActive = active === item.id;
        return (
          <button
            key={item.id}
            type="button"
            className={`sv2-bottom-nav-item${isActive ? " is-active" : ""}`}
            data-testid={item.testId}
            aria-current={isActive ? "page" : undefined}
            onClick={() => onNavigate(item.id)}
          >
            <span className="sv2-bottom-nav-icon" aria-hidden="true">
              {item.icon}
              {item.id === "cart" && cartCount > 0 ? (
                <span className="sv2-bottom-nav-badge">{cartCount > 99 ? "99+" : cartCount}</span>
              ) : null}
            </span>
            <span className="sv2-bottom-nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
